var $ = require("jquery");

const selector = [
  ".gform_wrapper input[type='text']",
  ".gform_wrapper input[type='email']",
  ".gform_wrapper textarea"
];

const items = selector.join(", ");

$(document).ready(() => {
  // Check if input has value already
  $(items).each(function() {
    var $this = $(this);
    var attr = $this.val();

    if (typeof attr !== typeof undefined && attr !== false && attr !== "") {
      $this.parents(".gfield").addClass("gfield--is-open");
    }
  });

  // Add on event change function
  $(items).on("focus focusout change keydown paste input", function(e) {
    var $parent = $(this).parents(".gfield");

    if (e.type === "focus") {
      $parent.addClass("gfield--is-open");
    }

    if (e.type === "focusout") {
      if ($(this).val()) {
        $parent.addClass("gfield--is-open");
      }

      if (!$(this).val() && $parent.hasClass("gfield--is-open")) {
        $parent.removeClass("gfield--is-open");
      }
    }
  });
});
